import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5ee53447"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "software-disabled-wrap" }

import PageSubscribeBar from '@/views/dashboard/_components/subscribe-bar/page-subscribe-bar.vue'
import { PermissionFe, ServicePermissionService } from '@/services/service-permission.service'
import { PolicyType } from '@/views/dashboard/_enum/policy-type'
import { TableOptColumn } from '@/components/cmTable/types'
import {
  StrategyListData,
  SoftwareDisabledService,
  softDisableTopList,
  softDisableGroupList,
  SoftwareDisabledProcessInfo,
} from '@/views/dashboard/policy/software-disabled/software-disabled.service'
import type { StrategyListDataCommon } from '@/views/dashboard/policy/policy-common.service'
import TaskTimeShow from '@/views/dashboard/_components/task-time/task-time-show.vue'
import StatisticsCards from './_components/statistics-cards.vue'
import SoftwareInterceptionRankingChart from './_components/software-interception-ranking-chart.vue'
import SoftwareInterceptionDistributionChart from './_components/software-interception-distribution-chart.vue'
import SoftwareDisabledLogList from './_components/software-disabled-log-list/software-disabled-log-list.vue'
import ProcessInfosListDrawer from './_components/process-infos-list-drawer/process-infos-list-drawer.vue'
import { ref, reactive, onMounted, nextTick, computed } from 'vue'
import PolicyManage from '@/views/dashboard/_components/policy-manage/policy-manage.vue'
import SoftwareDisabledEdit from '@/views/dashboard/policy/software-disabled-edit/software-disabled-edit.vue'
import ItemGroup from '@/views/_components/item-group/item-group.vue'
import Card from '@/views/dashboard/_components/card/card.vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { BusinessScene, Software, SoftwareSelectService } from '@/services/software-select.service'
import { TableViewMode } from '@/views/dashboard/_enum/table-view-mode'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'
import { getTimeRangeByEnum } from '@/utils/time'
import dayjs from 'dayjs'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'software-disabled',
  setup(__props) {

const { t, locale } = useI18n()

const injector = useReflectiveInjector([SoftwareSelectService, SoftwareDisabledService])
const softwareSelectService = injector.get(SoftwareSelectService)
const softwareDisabledService = injector.get(SoftwareDisabledService)
const servicePermissionService = injector.get(ServicePermissionService)
const hasPermission = servicePermissionService.getHasPermission(PermissionFe.soft_disable)

const targetObjectsDrawerVisible = ref(false)
const targetObjectsDrawerPolicyName = ref('')
const targetObjectsDrawerPolicyId = ref('')
const targetObjectsDrawerProcessRows = ref<SoftwareDisabledProcessInfo[]>([])
const targetObjectsDrawerDefaultTab = ref<'software' | 'process'>('software')
const softwareLib = ref<Software[]>([])
const logDrawerVisible = ref(false)
const logDrawerTitle = ref('')
const logDrawerPresetStrategyId = ref<string | undefined>(undefined)
const logDrawerPresetDateRange = ref<[string, string] | undefined>(undefined)
const logDrawerPresetKeyWord = ref<string | undefined>(undefined)
const logDrawerPresetGroupId = ref<number | undefined>(undefined)
const softwareInterceptionRankingChartRef = ref()
const policyEditDrawerVisible = ref(false)
const policyEditPolicyId = ref('')

function handlePolicyAction({ type, rowItem }: { type: string; rowItem?: any }) {
  if (type === 'add' || type === 'edit') {
    policyEditPolicyId.value = type === 'edit' ? rowItem?.id ?? '' : ''
    policyEditDrawerVisible.value = true
  }
}

const policyManageRef = ref()

function onPolicyEditSuccess() {
  policyEditDrawerVisible.value = false
  policyManageRef.value?.tableRef?.getList()
  loadStatistics()
}

// 统计数据
const statistics = reactive({
  controlledSoftwareCount: 0,
  interceptionCount30Days: 0,
  activePolicyCount: 0,
  involvedTerminalCount: 0
})

// 图表数据
const rankingData = ref<softDisableTopList[]>([])
const distributionData = ref<softDisableGroupList[]>([])
const rankingTimeRange = ref<TimeRange>(TimeRange.DAYS_30)
const distributionTimeRange = ref<TimeRange>(TimeRange.DAYS_30)

const customCols = computed<TableOptColumn[]>(() => {
  void locale.value
  return [
    {
      label: t('softwareDisabledLog.colPolicyAttr'),
      prop: 'interval_type',
      columnOpt: { minWidth: 80 },
      formatter: (row: StrategyListData) =>
        row.strategy.interval_type === 1 ? t('softwareDisabledLog.blacklist') : t('softwareDisabledLog.whitelist'),
    },
    {
      label: t('softwareDisabledLog.colTargetObjectsManage'),
      prop: 'target_objects',
      columnOpt: { minWidth: 160 },
    },
    {
      label: t('softwareDisabledLog.colExecTime'),
      prop: 'strategy.frequency',
      columnOpt: { minWidth: 160 },
    },
  ]
})

function parseProcessDisplayList (row: StrategyListData): string[] {
  void locale.value
  const list = row.strategy?.process_infos ?? []
  if (!list.length) return []
  return list.map((p) => {
    const n = String(p.name ?? '').trim()
    if (n) return n
    const path = String(p.path ?? '').trim()
    return path || '--'
  })
}

/** 合并列预览：仅软件 / 仅进程各展示 1 条；两者皆有时各展示首条（最多 2 条，与 ItemGroup.max 一致） */
function parseTargetObjectsPreview (row: StrategyListData): string[] {
  void locale.value
  const softIds = row.strategy?.software_ids ?? []
  const procRows = row.strategy?.process_infos ?? []
  const soft = parseSoftNames(softIds)
  const proc = parseProcessDisplayList(row)
  if (softIds.length && procRows.length && soft.length && proc.length) {
    return [soft[0], proc[0]]
  }
  if (soft.length) return [soft[0]]
  if (proc.length) return [proc[0]]
  return []
}

function targetObjectsPreviewMax (row: StrategyListData): number {
  const softN = row.strategy?.software_ids?.length ?? 0
  const procN = row.strategy?.process_infos?.length ?? 0
  return softN > 0 && procN > 0 ? 2 : 1
}

function targetObjectsTotal (row: StrategyListData): number {
  return (row.strategy?.software_ids?.length ?? 0) + (row.strategy?.process_infos?.length ?? 0)
}

function openTargetObjectsDrawer (row: StrategyListData) {
  const softN = row.strategy?.software_ids?.length ?? 0
  const procN = row.strategy?.process_infos?.length ?? 0
  targetObjectsDrawerDefaultTab.value = softN > 0 ? 'software' : 'process'
  targetObjectsDrawerPolicyName.value = row.name?.trim() || ''
  targetObjectsDrawerPolicyId.value = row.id ?? ''
  targetObjectsDrawerProcessRows.value = procN ? [...(row.strategy.process_infos ?? [])] : []
  targetObjectsDrawerVisible.value = true
}

// 加载统计数据
async function loadStatistics() {
  if (!hasPermission) return

  try {
    const res = await softwareDisabledService.getSoftmgrSoftDisableStat()

    // 受控软件数量：需要从策略列表中获取所有软件ID并去重
    // 暂时使用 list 的长度作为估算，实际应该从策略列表中统计
    // TODO: 如果 API 返回受控软件数量字段，应该使用该字段
    statistics.controlledSoftwareCount = res.controlled_soft_count || 0

    // 拦截次数（近30天）：使用 total 字段
    statistics.interceptionCount30Days = res.total || 0

    // 生效策略数量
    statistics.activePolicyCount = res.enable_count || 0

    // 涉及终端数量
    statistics.involvedTerminalCount = res.terminal_count || 0
  } catch (error) {
    console.error('加载统计数据失败:', error)
  }
}

// 加载排行数据
async function loadRankingData() {
  if (!hasPermission) return

  if (softwareInterceptionRankingChartRef.value) {
    softwareInterceptionRankingChartRef.value.loading = true
  }
  try {
    const [start_time, end_time] = getTimeRangeByEnum(rankingTimeRange.value)

    const res = await softwareDisabledService.getSoftmgrSoftDisableTop({
      start_time: start_time.toString(),
      end_time: end_time.toString()
    })

    rankingData.value = res.list || []
  } catch (error) {
    console.error('加载排行数据失败:', error)
    rankingData.value = []
  } finally {
    if (softwareInterceptionRankingChartRef.value) {
      softwareInterceptionRankingChartRef.value.loading = false
    }
  }
}

// 加载分布数据
async function loadDistributionData() {
  if (!hasPermission) return

  try {
    const [start_time, end_time] = getTimeRangeByEnum(distributionTimeRange.value)

    const res = await softwareDisabledService.getSoftmgrSoftDisableGroup({
      start_time: start_time.toString(),
      end_time: end_time.toString()
    })

    distributionData.value = res.list || []
  } catch (error) {
    console.error('加载分布数据失败:', error)
    distributionData.value = []
  }
}

function handleRankingTimeRangeChange(value: TimeRange) {
  rankingTimeRange.value = value
  loadRankingData()
}

function handleDistributionTimeRangeChange(value: TimeRange) {
  distributionTimeRange.value = value
  loadDistributionData()
}

/** 图表当前时间范围 → 日志抽屉日期（与图表请求区间一致；「全部」时不传，列表用默认近三月） */
function timeRangeToPresetDateRange (tr: TimeRange): [string, string] | undefined {
  const [startSec, endSec] = getTimeRangeByEnum(tr)
  if (startSec == null || endSec == null) return undefined
  return [dayjs.unix(startSec).format('YYYY-MM-DD'), dayjs.unix(endSec).format('YYYY-MM-DD')]
}

function openLogDrawerFromCharts (opts: {
  name?: string
  groupId?: number
  /** 分布图扇区名称，用于抽屉标题展示 */
  groupLabel?: string
  dateRange: [string, string] | undefined
}) {
  logDrawerPresetStrategyId.value = undefined
  logDrawerPresetDateRange.value = opts.dateRange
  logDrawerPresetKeyWord.value = opts.name?.trim() || undefined
  logDrawerPresetGroupId.value =
    opts.groupId != null && Number.isFinite(opts.groupId) ? opts.groupId : undefined

  const kw = logDrawerPresetKeyWord.value
  const gid = logDrawerPresetGroupId.value
  const gl = (opts.groupLabel ?? '').trim()

  if (kw && gid != null && gl) {
    logDrawerTitle.value = t('softwareDisabledLog.chartFilterLogDrawerKwAndGroup', { keyword: kw, group: gl })
  } else if (kw && gid != null) {
    logDrawerTitle.value = t('softwareDisabledLog.chartFilterLogDrawerKwAndGroup', { keyword: kw, group: String(gid) })
  } else if (kw) {
    logDrawerTitle.value = t('softwareDisabledLog.chartFilterLogDrawerTitle', { keyword: kw })
  } else if (gid != null && gl) {
    logDrawerTitle.value = t('softwareDisabledLog.chartFilterLogDrawerGroupTitle', { group: gl })
  } else if (gid != null) {
    logDrawerTitle.value = t('softwareDisabledLog.chartFilterLogDrawerGroupTitle', { group: String(gid) })
  } else {
    logDrawerTitle.value = t('softwareDisabledLog.fullLogDrawerTitle')
  }
  logDrawerVisible.value = true
}

function handleRankingChartItemClick (payload: { rawName: string }) {
  if (!hasPermission) return
  openLogDrawerFromCharts({
    name: payload.rawName || undefined,
    groupId: undefined,
    groupLabel: undefined,
    dateRange: timeRangeToPresetDateRange(rankingTimeRange.value),
  })
}

function handleDistributionChartSliceClick (payload: { groupId?: number; groupName?: string }) {
  if (!hasPermission) return
  const name = (payload.groupName ?? '').trim()
  const hasGid = payload.groupId != null && Number.isFinite(payload.groupId)
  openLogDrawerFromCharts({
    name,
    groupId: hasGid ? payload.groupId : undefined,
    dateRange: timeRangeToPresetDateRange(distributionTimeRange.value),
  })
}

function viewAllLogs () {
  if (!hasPermission) return
  logDrawerPresetStrategyId.value = undefined
  logDrawerPresetDateRange.value = undefined
  logDrawerPresetKeyWord.value = undefined
  logDrawerPresetGroupId.value = undefined
  logDrawerTitle.value = t('softwareDisabledLog.fullLogDrawerTitle')
  logDrawerVisible.value = true
}

/** 策略列表点击「执行时间」：带策略名称与近一月时间范围打开禁用日志抽屉 */
function triggerTimeCallback (item: StrategyListDataCommon) {
  const end = dayjs().format('YYYY-MM-DD')
  const start = dayjs().subtract(1, 'month').format('YYYY-MM-DD')
  logDrawerPresetStrategyId.value = item.id
  logDrawerPresetDateRange.value = [start, end]
  logDrawerPresetKeyWord.value = undefined
  logDrawerPresetGroupId.value = undefined
  logDrawerTitle.value = t('softwareDisabledLog.strategyLogDrawerTitle')
  logDrawerVisible.value = true
}

function updateSoftwareLib () {
  softwareSelectService.getAllSoftware(BusinessScene.softwareDisable).then(response => {
    softwareLib.value = response
  })
}

function parseSoftNames (softIds: number[] = []) {
  void locale.value
  return softIds.slice(0, 5).map((id) => {
    const item = softwareLib.value.find(soft => soft.soft_id === id)
    return item?.soft_name || t('softwareDisabledLog.unknownSoftName')
  })
}

onMounted(async () => {
  if (!hasPermission) return
  await nextTick()
  loadStatistics()
  loadRankingData()
  loadDistributionData()
  updateSoftwareLib()
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PageSubscribeBar, {
        "normal-permission-key": _unref(PermissionFe).soft_disable
      }, null, 8, ["normal-permission-key"]),
      _createVNode(StatisticsCards, {
        "controlled-software-count": statistics.controlledSoftwareCount,
        "interception-count30-days": statistics.interceptionCount30Days,
        "active-policy-count": statistics.activePolicyCount,
        "involved-terminal-count": statistics.involvedTerminalCount
      }, null, 8, ["controlled-software-count", "interception-count30-days", "active-policy-count", "involved-terminal-count"]),
      _createVNode(_component_el_row, {
        gutter: 16,
        class: "charts-row"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createVNode(SoftwareInterceptionRankingChart, {
                ref_key: "softwareInterceptionRankingChartRef",
                ref: softwareInterceptionRankingChartRef,
                data: rankingData.value,
                onTimeRangeChange: handleRankingTimeRangeChange,
                onItemClick: handleRankingChartItemClick
              }, null, 8, ["data"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createVNode(SoftwareInterceptionDistributionChart, {
                data: distributionData.value,
                onTimeRangeChange: handleDistributionTimeRangeChange,
                onSliceClick: handleDistributionChartSliceClick
              }, null, 8, ["data"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(Card, {
        size: "second",
        title: _ctx.$t('softwareDisabledLog.previewSectionTitle'),
        class: "cm-ui-mt16"
      }, {
        titleAfter: _withCtx(() => [
          _createVNode(_component_el_tag, { size: "small" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
            ]),
            _: 1
          })
        ]),
        headerRight: _withCtx(() => [
          _createVNode(_component_el_button, {
            size: "small",
            disabled: !_unref(hasPermission),
            onClick: viewAllLogs
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('softwareDisabledLog.viewAllLogs')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        default: _withCtx(() => [
          _createVNode(SoftwareDisabledLogList, {
            "view-mode": _unref(TableViewMode).preview,
            "has-permission": _unref(hasPermission)
          }, null, 8, ["view-mode", "has-permission"])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(PolicyManage, {
        ref_key: "policyManageRef",
        ref: policyManageRef,
        class: "cm-ui-mt16",
        title: _ctx.$t('softwareDisabledLog.policyList'),
        "normal-permission-key": _unref(PermissionFe).soft_disable,
        "strategy-type": _unref(PolicyType).softwareDisabled,
        triggerTimeCallback: triggerTimeCallback,
        "custom-cols": customCols.value,
        "edit-in-drawer": "",
        "log-route": "/dashboard/soft-disabled-log",
        "log-btn-text": _ctx.$t('softwareDisabledLog.viewSoftDisabledLogs'),
        onHandleAction: handlePolicyAction
      }, {
        table__target_objects: _withCtx((scope) => [
          _createVNode(ItemGroup, {
            onClick: ($event: any) => (openTargetObjectsDrawer(scope.row)),
            max: targetObjectsPreviewMax(scope.row),
            data: parseTargetObjectsPreview(scope.row),
            "custom-total": targetObjectsTotal(scope.row),
            tooltip: false,
            unit: _ctx.$t('common.unitItems')
          }, null, 8, ["onClick", "max", "data", "custom-total", "unit"])
        ]),
        "table__strategy.frequency": _withCtx((scope) => [
          _createVNode(TaskTimeShow, {
            frequency: scope.row.strategy.frequency,
            "task-time": scope.row.strategy.regular_tasks
          }, null, 8, ["frequency", "task-time"])
        ]),
        _: 1
      }, 8, ["title", "normal-permission-key", "strategy-type", "custom-cols", "log-btn-text"])
    ]),
    _createVNode(_component_el_drawer, {
      size: "80%",
      title: logDrawerTitle.value,
      modelValue: logDrawerVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((logDrawerVisible).value = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(SoftwareDisabledLogList, {
          "view-mode": _unref(TableViewMode).full,
          "has-permission": _unref(hasPermission),
          "preset-strategy-id": logDrawerPresetStrategyId.value,
          "preset-date-range": logDrawerPresetDateRange.value,
          "preset-group-id": logDrawerPresetGroupId.value,
          style: {"padding":"16px 16px 0"}
        }, null, 8, ["view-mode", "has-permission", "preset-strategy-id", "preset-date-range", "preset-group-id"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(ProcessInfosListDrawer, {
      modelValue: targetObjectsDrawerVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((targetObjectsDrawerVisible).value = $event)),
      "policy-name": targetObjectsDrawerPolicyName.value,
      "policy-id": targetObjectsDrawerPolicyId.value,
      "process-infos": targetObjectsDrawerProcessRows.value,
      "default-tab": targetObjectsDrawerDefaultTab.value
    }, null, 8, ["modelValue", "policy-name", "policy-id", "process-infos", "default-tab"]),
    _createVNode(_component_el_drawer, {
      modelValue: policyEditDrawerVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((policyEditDrawerVisible).value = $event)),
      title: _ctx.$t('softwareDisabledLog.policyEditDrawerTitle'),
      size: "75%",
      "destroy-on-close": "",
      direction: "rtl"
    }, {
      default: _withCtx(() => [
        (policyEditDrawerVisible.value)
          ? (_openBlock(), _createBlock(SoftwareDisabledEdit, {
              key: 0,
              "drawer-mode": "",
              "initial-policy-id": policyEditPolicyId.value,
              onClose: _cache[2] || (_cache[2] = ($event: any) => (policyEditDrawerVisible.value = false)),
              onSuccess: onPolicyEditSuccess
            }, null, 8, ["initial-policy-id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})